// ── Intro: mostrar botón después de 2.5s
setTimeout(function () {
  var btn = document.getElementById('enterBtn');
  if (btn) btn.classList.add('visible');
}, 2600);

// ── Entrar al sitio
function enterSite() {
  var intro = document.getElementById('intro');
  intro.classList.add('hidden');
  setTimeout(function () {
    intro.style.display = 'none';
    var site = document.getElementById('site');
    site.style.display = 'block';
    site.classList.add('active');
  }, 800);
}

// ── Selector de color
function selectColor(el) {
  document.querySelectorAll('.cdot').forEach(function (d) {
    d.classList.remove('sel');
  });
  el.classList.add('sel');
}

// ── Carrito (fallback si no hay producto Shopify conectado)
var cartCount = 0;
function addToCart() {
  cartCount++;
  var badge = document.getElementById('cartCount');
  if (badge) badge.textContent = cartCount;
  var btn = document.querySelector('.btn-add');
  if (!btn) return;
  var original = btn.textContent;
  btn.textContent = '✓ AGREGADO';
  btn.style.background = '#1a1a1a';
  btn.style.color = '#888';
  setTimeout(function () {
    btn.textContent = original;
    btn.style.background = '#fff';
    btn.style.color = '#080808';
  }, 2000);
}

// ── Nav activo al hacer scroll
document.addEventListener('DOMContentLoaded', function () {
  var sections = document.querySelectorAll('section[id]');
  var navLinks = document.querySelectorAll('.kb-nav-link');
  window.addEventListener('scroll', function () {
    var scrollY = window.scrollY;
    sections.forEach(function (section) {
      if (scrollY >= section.offsetTop - 120) {
        navLinks.forEach(function (link) {
          link.style.color = '#444';
          link.style.borderBottomColor = 'transparent';
        });
        var active = document.querySelector('.kb-nav-link[href="#' + section.id + '"]');
        if (active) {
          active.style.color = '#ccc';
          active.style.borderBottomColor = '#333';
        }
      }
    });
  });
});
(function () {
  var num = document.getElementById('kodeViewersNum');
  if (!num) return;
  var current = Math.floor(Math.random() * 4) + 2;
  num.textContent = current;

  setInterval(function () {
    var n;
    do { n = Math.floor(Math.random() * 4) + 2; } while (n === current);
    current = n;
    num.textContent = n;
  }, 60000);
})();